import React from 'react';
import { BsFillPeopleFill } from 'react-icons/bs';

interface CommunityPanelProps {
  community: any;
  onVisit: (community: any) => void;
}

class CommunityPanel extends React.Component<CommunityPanelProps> {
  render() {
    const { community, onVisit } = this.props;

    let icon = community.icon;
    if(icon.indexOf('https://s3.us-west-2.amazonaws.com/oneclick.media') !== -1) 
      icon = icon.replace('https://s3.us-west-2.amazonaws.com/oneclick.media', 'https://d27jhqexqrz634.cloudfront.net');

    let activity = new Date(community.activity).toLocaleString(undefined, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});
    let founders = community.founders;

    return (
      <div style={{border: '1px solid var(--panel-border-color)', borderRadius: 'var(--panel-border-radius)', padding: '5px'}}>
        {founders &&
          <div style={{
            backgroundColor: 'var(--notification-background-color)', 
            color: 'var(--notification-color)',
            padding: '5px', 
            borderRadius: '5px',
            fontSize: '0.9em',
            marginBottom: '5px'
          }}>
            Founders Club
          </div>
        }
        <div className="join-page-community-row" onClick={() => onVisit(community)}>
          <img style={{width: '40px'}} src={icon}/>
          <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '15px'}}>
              <div>{community.name}</div>
              <div>{community.members}&nbsp;&nbsp;<BsFillPeopleFill style={{fontSize: '1.1em', marginBottom: '-3px'}} /></div>
            </div>
            <div style={{fontSize: '0.9em', marginTop: '2px', marginRight: '45px'}}>{community.description}</div>
            <div style={{fontSize: '0.9em', marginTop: '2px'}}>
                Last activity {activity}
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CommunityPanel;
